import { AnimatedSprite } from 'pixi.js';
import { gameConfig } from '../config/gameConfig.js';
import { loadSpritesheetFrames } from './spritesheetLoader.js';

const FIRE_SPRITE_PATH = '/assets/spritesheet/fire_sprite';

/**
 * @returns {Promise<import('pixi.js').Texture[]>}
 */
export async function loadFireWinSpriteFrames() {
  try {
    return await loadSpritesheetFrames(FIRE_SPRITE_PATH);
  } catch (err) {
    console.warn('Failed to load fire win spritesheet:', err);
    return [];
  }
}

/**
 * @param {import('pixi.js').Texture[]} textures
 * @returns {AnimatedSprite | null}
 */
export function createFireWinAnimatedSprite(textures) {
  if (!textures?.length) return null;

  const cfg = gameConfig.adapter;
  const { cellWidth, cellHeight } = gameConfig;
  const frameW = textures[0].width;
  const frameH = textures[0].height;
  const widthPad = cfg.winFireWidthPad ?? 0.72;
  const heightPad = cfg.winFireHeightPad ?? 0.95;

  const sprite = new AnimatedSprite(textures);
  sprite.scale.set((cellWidth * widthPad) / frameW, (cellHeight * heightPad) / frameH);
  sprite.anchor.set(0.5, cfg.winFireAnchorY ?? 0.96);
  sprite.y = cfg.winFireOffsetY ?? 30;
  sprite.loop = true;
  sprite.animationSpeed = cfg.winFireAnimSpeed ?? 0.28;
  sprite.visible = true;
  sprite.eventMode = 'none';
  sprite.alpha = cfg.winFireAlpha ?? 0.9;
  sprite.blendMode = 'add';
  return sprite;
}
